import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Responsible from "../components/responsible"
/*
    TODO: change / check FB and youtube links
*/
const TermsPage = () => (
    <Layout>
        <SEO title="Terms of use" />
        <div className={"container"}>
            <div className={"content"}>
                <div className={"title"}>
                    <h1>Impressum</h1>
                </div>
                
                <h2>Diensteanbieter</h2>
                <Responsible />
                
                <h2>Social Media und andere Onlinepräsenzen</h2>
                <p><strong>Dieses Impressum gilt auch für die folgenden Social-Media-Präsenzen und Onlineprofile:</strong> </p>
                <p><a href="https://www.facebook.com/voka.box.1" target="_blank" rel="noopener noreferrer">https://www.facebook.com/voka.box.1</a></p>
                <p><a href="https://www.instagram.com/vokabox/" target="_blank" rel="noopener noreferrer">https://www.instagram.com/vokabox/</a></p>
                
                <h2>Haftungs- und Schutzrechtshinweise</h2>
                <p><strong>Haftungsausschluss</strong>: Die Inhalte dieses Onlineangebotes wurden sorgfältig und nach unserem aktuellen Kenntnisstand erstellt, dienen jedoch nur der Information und entfalten keine rechtlich bindende Wirkung, sofern es sich nicht um gesetzlich verpflichtende Informationen (z.B. das <a href="https://vokabox.com/terms">Impressum</a>, die <a href="https://vokabox.com/privacy">Datenschutzerklärung</a>, AGB oder verpflichtende Belehrungen von Verbrauchern) handelt. Wir behalten uns vor, die Inhalte vollständig oder teilweise zu ändern oder zu löschen, soweit vertragliche Verpflichtungen unberührt bleiben. Alle Angebote sind freibleibend und unverbindlich. </p>

                <p><strong>Links auf fremde Webseiten</strong>: Inhalte fremder Webseiten, auf die wir direkt oder indirekt verweisen, liegen außerhalb unseres Verantwortungsbereiches und machen wir uns nicht zu Eigen. Für alle Inhalte und insbesondere für Schäden, die aus der Nutzung der in den verlinkten Webseiten aufrufbaren Informationen entstehen, haftet allein der Anbieter der verlinkten Webseiten.</p>
                
                <p><strong>Urheberrechte und Markenrechte</strong>: Alle auf dieser Website dargestellten Inhalte, wie Texte, Fotografien, Grafiken, Marken und Warenzeichen sind durch die jeweiligen Schutzrechte (Urheberrechte, Markenrechte) geschützt. Die Verwendung, Vervielfältigung usw. unterliegen unseren Rechten oder den Rechten der jeweiligen Urheber bzw. Rechteverwalter.</p>

                <p><strong>Hinweise auf Rechtsverstöße</strong>: Sollten Sie innerhalb unseres Internetauftritts Rechtsverstöße bemerken, bitten wir Sie uns auf diese hinzuweisen. Wir werden rechtswidrige Inhalte und Links nach Kenntnisnahme unverzüglich entfernen.</p>
                
                {/*
                <h2>Bildnachweise</h2><p><strong>Bildquellen und Urheberrechtshinweise:</strong> </p>
                <p>Justus Barg | (www.if u wanna)</p>
                <p>?Bilder der app?</p>
                */}

                <p><a href="https://datenschutz-generator.de/impressum/?l=de" title="Rechtstext von Dr. Schwenke - für weitere Informationen bitte anklicken." target="_blank" rel="noopener noreferrer nofollow">Erstellt mit kostenlosem Datenschutz-Generator.de von Dr. Thomas Schwenke</a></p>
            </div>
        </div>
  </Layout>
)

export default TermsPage
